var D = /* @__PURE__ */ ((E) => (E[E.PENDING = 1] = "PENDING", E[E.CONFIRMED = 2] = "CONFIRMED", E[E.PROCESSED = 3] = "PROCESSED", E[E.CANCELED = 4] = "CANCELED", E[E.EXPIRED = 10] = "EXPIRED", E))(D || {});
export {
  D as ShopSessionStatus
};
//# sourceMappingURL=shopSessionStatus.js.map
